import axios from "axios";
import { Company } from "../../model/company";

export const doCompanyFetchApiCall = ({ id }: { id: number }) => {
  return axios.get<Company>(`/api/companies/${id}`);
};
